import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "key" }), /* @__PURE__ */ _jsx("path", {
		d: "M15.5 8.5H15.5117M15.5 15.5C19.366 15.5 22.5 12.366 22.5 8.5C22.5 4.63401 19.366 1.5 15.5 1.5C11.634 1.5 8.5 4.63401 8.5 8.5C8.5 8.81929 8.52138 9.13359 8.56278 9.44154C8.63087 9.94804 8.66492 10.2013 8.642 10.3615C8.61813 10.5284 8.58773 10.6184 8.50547 10.7655C8.4265 10.9068 8.28733 11.046 8.00899 11.3243L2.04673 17.2866C1.84496 17.4884 1.74407 17.5893 1.67192 17.707C1.60795 17.8114 1.56081 17.9252 1.53224 18.0442C1.5 18.1785 1.5 18.3212 1.5 18.6065V20.6333C1.5 21.2867 1.5 21.6134 1.62716 21.863C1.73901 22.0825 1.91749 22.261 2.13701 22.3728C2.38657 22.5 2.71327 22.5 3.36667 22.5H5.39347C5.67882 22.5 5.8215 22.5 5.95577 22.4678C6.07481 22.4392 6.18861 22.392 6.293 22.3281C6.41073 22.2559 6.51162 22.155 6.7134 21.9533L12.6757 15.991C12.954 15.7127 13.0932 15.5735 13.2345 15.4945C13.3816 15.4123 13.4716 15.3819 13.6385 15.358C13.7987 15.3351 14.052 15.3691 14.5585 15.4372C14.8664 15.4786 15.1807 15.5 15.5 15.5Z",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgKey;
